// extracted by mini-css-extract-plugin
export default {"wrapper":"Options_wrapper__n4OZ3","option":"Options_option__g6txG"};